import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Job } from '../domain/job';
import { MenuItem } from 'primeng/api';
import { JobsService } from '../services/jobs.service';
import {
  CSS_FAILED,
  CSS_OK,
  CSS_WARNING,
  STATUS_COMPLETE,
  STATUS_FAILED,
  STATUS_FORECAST, STATUS_MESSAGE_WAITING,
  STATUS_RUNNING
} from '../services/shared-data.service';
import * as _ from 'underscore';


@Component({
    selector: 'app-business',
    templateUrl: './business.component.html',
    styleUrls: ['./business.component.css'],
    standalone: false
})
export class BusinessComponent implements OnInit {

  home: MenuItem;
  resource: string;
  application: string;
  loc_pos: string;
  jobname: string;
  jobnameCard: string;
  applications: SelectItem[];
  locations: SelectItem[];
  jobnames: SelectItem[];
  data: string[];
  jobs: Job[];
  job: Job;
  jobSelected: Job[];
  jobPrevious: Job[];
  jobForecast: Job[];

  error: string;
  uri: string;
  ExecutionCard: boolean;
  progressSpinner: boolean;
  PageContent: boolean;

  cardOpen: boolean
  tabla: boolean;
  cardIcon: String;

  cardOpenForecast: boolean;
  tablaForecast: boolean;
  cardIconForecast: String;

  constructor(private jobsService: JobsService) { }

  ngOnInit() {
    this.PageContent = true;
    this.ExecutionCard = true;
    this.jobs = [];
    this.jobSelected = [];
    this.jobForecast = [];
    this.jobPrevious = [];
    this.applications = [];
    this.locations = [];
    this.jobnames = [];
    this.application = '';
    this.loc_pos = '';
    this.jobname = '';
    this.jobnameCard = '';
    this.cardOpen = false;
    this.cardOpenForecast = false;
    this.tabla = true;
    this.cardIcon = 'fa fa-list-ul';
    this.getJobs('Prod-Europe');
  }

  getJobs(resource: string): void {
    this.progressSpinner = false;
    setTimeout(() => {
      this.jobsService.getJobs(resource)
        .subscribe(jobs => {
          this.jobs = jobs;
          this.listLocations();
          this.progressSpinner = true;
          this.PageContent = false;
        }
        );
    });
  }

  listApplications(): void {
    this.jobs.forEach(job => {
      // If location(loc_pos) is not currently in the list, it is added (Distinct)
      if (this.loc_pos === job.location) {
        if ('BLESS Receivables' === job.appFullName && _.findLastIndex(this.applications, { label: 'REC', value: job.appFullName }) < 0)
          this.applications.push({ label: 'REC', value: job.appFullName });
        if ('BLESS Wholesale' === job.appFullName && _.findLastIndex(this.applications, { label: 'WHS', value: job.appFullName }) < 0)
          this.applications.push({ label: 'WHS', value: job.appFullName });
        if ('MIS' === job.appFullName && _.findLastIndex(this.applications, { label: 'MIS', value: job.appFullName }) < 0)
          this.applications.push({ label: 'MIS', value: job.appFullName });
      }
    }
    );
    this.applications = _.sortBy(this.applications, 'value');
  }

  listLocations(): void {
    this.jobs.forEach(job => {
      // If location is not currently in the list, it is added (Distinct)
      if (('BLESS Receivables' === job.appFullName || 'BLESS Wholesale' === job.appFullName
        || 'MIS' === job.appFullName)
        && _.findLastIndex(this.locations, { label: job.location, value: job.location }) < 0)
        this.locations.push({ label: job.location, value: job.location });
    }
    );

    this.locations = _.sortBy(this.locations, 'value');
  }

  listJobnames(): void {
    this.jobnames = [];

    this.jobs.forEach(job => {
      if (this.application === job.appFullName && this.loc_pos === job.location) {

        let jobNameCode = job.jobName.substring(job.jobName.length - 3, job.jobName.length);

        switch (jobNameCode) {
          case 'NI1':
            this.addToJobnames('MD 1', job);
            break;
          case 'NI2':
            this.addToJobnames('MD 2', job);
            break;
          case 'NI3':
            this.addToJobnames('MD 3', job);
            break;
          case 'DAY':
            this.addToJobnames('Daily', job);
            break;
          case 'NIT':
            this.addToJobnames('Nitepost', job);
            break;
          case 'MTH':
            this.addToJobnames('MonthEnd', job);
            break;
        }
      }
    });

    this.jobnames = _.sortBy(this.jobnames, 'value');

  }

  addToJobnames(labelvalue: string, job: Job) {
    if (_.findLastIndex(this.jobnames, { label: labelvalue, value: job.jobName }) < 0)
      this.jobnames.push({ label: labelvalue, value: job.jobName })
  }

  locationClicked(location) {
    this.jobnames = [];
    this.jobname = '';
    this.applications = [];
    this.application = '';
    this.ExecutionCard = true;
    this.jobSelected = [];
    this.jobForecast = [];
    this.jobPrevious = [];
    this.tabla = true;
    this.cardOpen = false;
    this.cardOpenForecast = false;
    this.cardIcon = 'fa fa-plus';
    this.listApplications();
  }

  applicationClicked(application) {
    this.jobnames = [];
    this.jobname = '';
    this.ExecutionCard = true;
    this.jobSelected = [];
    this.jobForecast = [];
    this.jobPrevious = [];
    this.tabla = true;
    this.cardOpen = false;
    this.cardOpenForecast = false;
    this.cardIcon = 'fa fa-plus';
    this.listJobnames();
  }

  jobnameClicked(jobname) {
    this.ExecutionCard = true;
    this.tabla = true;
    this.cardOpen = false;
    this.cardOpenForecast = false;
    this.cardIcon = 'fa fa-plus';
    this.cardIconForecast = 'fa fa-plus';
    this.jobSelected = [];
    this.jobForecast = [];
    this.jobPrevious = [];
    if (this.application != '' && this.loc_pos != ''
      && this.jobname != '') {
      this.showCard();
    }
    else
      this.ExecutionCard = true;
  }

  showCard() {
    this.jobSelected = [];
    this.jobForecast = [];
    this.jobPrevious = [];
    this.jobs.forEach(job => {
      if (this.application === job.appFullName && this.loc_pos === job.location
        && this.jobname === job.jobName) {

        if (job.status === STATUS_FORECAST) {
          this.jobForecast.push(job);
        } else {
          this.jobPrevious.push(job);
        }
      }
    }
    );

    this.jobPrevious = _.sortBy(this.jobPrevious, function (node) {
      return - (new Date(node.startDate).getTime());
    });
    this.jobForecast = _.sortBy(this.jobForecast, function (node) {
      return - (new Date(node.startDate).getTime());
    });
    this.jobForecast.reverse();

    this.jobSelected = this.jobPrevious;

    this.ExecutionCard = false;
  }

  statusHandler(status: string): string {
    if (status.indexOf(STATUS_COMPLETE) >= 0 || status.indexOf(STATUS_FORECAST) >= 0)
      return CSS_OK;
    else if (status.indexOf(STATUS_FAILED) >= 0 || status.indexOf(STATUS_MESSAGE_WAITING) >= 0)
      return CSS_FAILED;
    else if (status.indexOf(STATUS_RUNNING) >= 0)
      return CSS_WARNING;
  }

  statusIconHandler(status: string): string {
    if (status.indexOf(STATUS_COMPLETE) >= 0)
      return "fa fa-check";
    else if (status.indexOf(STATUS_FAILED) >= 0)
      return "fa fa-close";
    else if (status.indexOf(STATUS_RUNNING) >= 0)
      return "fa fa-spinner";
    else if (status.indexOf(STATUS_FORECAST) >= 0)
      return "fa fa-calendar";
    else
      return "fa fa-warning";
  }

  showmore() {
    if (this.cardOpen) {
      this.cardOpen = false;
      this.cardIcon = 'fa fa-plus';
      this.tabla = true;

    }
    else {
      this.cardOpen = true;
      this.cardIcon = 'fa fa-minus';
      this.tabla = false;

      this.cardOpenForecast = false;
      this.cardIconForecast = 'fa fa-plus';
      this.tablaForecast = true;
    }
  }

  showmoreForecast() {
    if (this.cardOpenForecast) {
      this.cardOpenForecast = false;
      this.cardIconForecast = 'fa fa-plus';
      this.tablaForecast = true;

    }
    else {
      this.cardOpenForecast = true;
      this.cardIconForecast = 'fa fa-minus';
      this.tablaForecast = false;

      this.cardOpen = false;
      this.cardIcon = 'fa fa-plus';
      this.tabla = true;
    }
  }

}
